export default "https://assets.pclncdn.com/web/next-landing/01bc7bc/_next/static/images/Three-a112201b65eb30d1dfecbdd118ebcc92.svg";